module.exports = __webpack_public_path__ + "static/media/py.77190226.jpg";